import { makeStyles, Theme } from '@material-ui/core/styles';
export const useStyles = makeStyles((theme: Theme) => ({
  displayTitle: {
    fontWeight: 700,
    fontSize: '16px',
    display: 'flex',
    justifyContent: 'center',
    margin: '12px 0px',
  },
  textBox: {
    fontWeight: 700,
    fontSize: '16px',
    width: '160px',
    display: 'inline-block',
  },
  textColor: {
    color: 'rgba(0, 0, 0, 54%)',
  },
  leftData: {
    paddingLeft: '12px',
    borderLeft: '1px solid rgba(0, 0, 0, 54%)',
  },
  displayBox: {
    marginTop: '12px',
  },
}));
